export enum TicketStatus {
    open = 1,
    pending = 2,
    completed = 3,
}
